export default __webpack_public_path__ + "static/media/apple_watch_2.e9e82446.png";